import React from 'react';
import { connect } from 'react-redux';
import { DESKTOP } from '@/constants';
import RadioButtonsSelectModal from './RadioButtonsSelectModal';

const RadioButtonsSelectModalComponent = props => <RadioButtonsSelectModal {...props} />;

const mapStateToProps = state => ({
  targetDevice: state.core.targetDevice
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { targetDevice } = stateProps;

  return {
    ...ownProps,
    isSmartphone: targetDevice !== DESKTOP,
  };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
)(RadioButtonsSelectModalComponent);
